import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faEdit,
  faSpinner,
  faPhone,
  faUser,
  faEnvelope,
  faMapMarkerAlt,
  faTimes,
  faSync,
  faAddressBook
} from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import './ContactoData.css'; // Puedes mantener estilos locales si los necesitas
import baseURL from '../../url';
import NewContact from '../NewContact/NewContact';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';


/* ================== Custom Toast (usa clases globales) ================== */
const CustomToast = ({ toasts }) => {
  if (toasts.length === 0) return null;
  return (
    <div className="product-toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`product-toast ${t.type}`}>
          <div className="toast-icon">
            {t.type === 'success' && '✅'}
            {t.type === 'error' && '❌'}
            {t.type === 'warning' && '⚠️'}
            {t.type === 'info' && 'ℹ️'}
          </div>
          <div className="toast-content">
            <div className="toast-title">{t.message}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default function ContactoData() {
  const [contactos, setContactos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toasts, setToasts] = useState([]);

  // Modal state
  const [modalVisible, setModalVisible] = useState(false);
  const [contacto, setContacto] = useState({});

  // Edit fields
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [nuevoTelefono, setNuevoTelefono] = useState('');
  const [nuevoInstagram, setNuevoInstagram] = useState('');
  const [nuevoEmail, setNuevoEmail] = useState('');
  const [nuevaDireccion, setNuevaDireccion] = useState('');
  const [nuevoFacebook, setNuevoFacebook] = useState('');

  useEffect(() => {
    cargarContacto();
  }, []);

  /* ================== Toast helper ================== */
  const showToast = (message, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3800);
  };

  /* ================== API ================== */
  const cargarContacto = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${baseURL}/contactoGet.php`, { method: 'GET' });
      const data = await res.json();
      setContactos(data.contacto || []);
    } catch (e) {
      console.error('Error al cargar contactos:', e);
      showToast('Error al cargar contactos', 'error');
    } finally {
      setLoading(false);
    }
  };

  const eliminarContacto = (idContacto) => {
    Swal.fire({
      title: '¿Eliminar contacto?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await fetch(`${baseURL}/contactoDelete.php?idContacto=${idContacto}`, {
            method: 'DELETE',
          });
          const data = await res.json();
          if (data?.mensaje) {
            showToast('Contacto eliminado', 'success');
            cargarContacto();
          } else {
            showToast(data?.error || 'No se pudo eliminar', 'error');
          }
        } catch (e) {
          console.error('Error al eliminar contacto:', e);
          showToast('Error al eliminar el contacto', 'error');
        }
      }
    });
  };

  /* ================== Modal ================== */
  const abrirModal = (item) => {
    setContacto(item);
    setNuevoNombre(item?.nombre ?? '');
    setNuevoTelefono(item?.telefono ?? '');
    setNuevoInstagram(item?.instagram ?? '');
    setNuevoEmail(item?.email ?? '');
    setNuevaDireccion(item?.direccion ?? '');
    setNuevoFacebook(item?.facebook ?? '');
    setModalVisible(true);
  };

  const cerrarModal = () => {
    setModalVisible(false);
  };

  const handleUpdateText = async (idContacto) => {
    const payload = {
      nombre: (nuevoNombre || contacto.nombre) ?? '',
      telefono: (nuevoTelefono || contacto.telefono) ?? '',
      instagram: (nuevoInstagram || contacto.instagram) ?? '',
      email: (nuevoEmail || contacto.email) ?? '',
      direccion: (nuevaDireccion || contacto.direccion) ?? '',
      facebook: (nuevoFacebook || contacto.facebook) ?? '',
    };

    try {
      const res = await fetch(`${baseURL}/contactoPut.php?idContacto=${idContacto}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data?.error) {
        showToast(data.error, 'error');
      } else {
        showToast(data?.mensaje || 'Contacto actualizado', 'success');
        cargarContacto();
        cerrarModal();
      }
    } catch (e) {
      console.log(e.message);
      showToast('Error al actualizar el contacto', 'error');
    }
  };

  const refreshData = () => {
    cargarContacto();
    showToast('Datos actualizados', 'info');
  };

  return (
    <div>
      <CustomToast toasts={toasts} />

{/* Header más compacto con lo actual */}
<div className="global-component-header" style={{ padding: '12px 16px' }}>
  <div className="flex-between">
    <div className="global-component-title">
      <FontAwesomeIcon icon={faAddressBook} />
      Gestión de Contactos
    </div>

    <div className="flex-center" style={{ gap: '12px' }}>
      <div className="global-stat-card compact" style={{marginLeft: "10px"}} >
        <span className="global-stat-number">{contactos.length}</span>
        <span className="global-stat-label">Contactos</span>
      </div>

      <button
        onClick={refreshData}
        className="btn-product-secondary compact flex-center"
        title="Actualizar"
      >
        <FontAwesomeIcon icon={faSync} />
      </button>
    </div>
  </div>
</div>

      {/* Crear nuevo contacto (tu componente existente) */}
      <NewContact />

      {/* Modal de edición (usa sistema global) */}
      {modalVisible && (
        <div className="product-modal-backdrop">
          <div className="product-modal-container" style={{ maxWidth: 800 }}>
            <div className="product-modal-header">
              <div className="product-modal-title">
                <FontAwesomeIcon icon={faEdit} />
                Editar contacto
              </div>
              <button className="product-close-button" onClick={cerrarModal}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="product-modal-body">
              <div className="product-section-card mb-24">
                <div className="product-section-header">
                  <div className="product-section-title">
                    <FontAwesomeIcon icon={faUser} />
                    Datos del contacto
                  </div>
                </div>

                <div className="product-section-content">
                  <div className="grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faUser} /> Nombre
                      </label>
                      <input
                        type="text"
                        className="product-form-input"
                        value={nuevoNombre}
                        onChange={(e) => setNuevoNombre(e.target.value)}
                        placeholder="Nombre"
                        maxLength={100}
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faPhone} /> Teléfono
                      </label>
                      <input
                        type="tel"
                        className="product-form-input"
                        value={nuevoTelefono}
                        onChange={(e) => setNuevoTelefono(e.target.value)}
                        placeholder="Teléfono"
                        maxLength={30}
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faInstagram} /> Instagram (URL)
                      </label>
                      <input
                        type="url"
                        className="product-form-input"
                        value={nuevoInstagram}
                        onChange={(e) => setNuevoInstagram(e.target.value)}
                        placeholder="https://instagram.com/usuario"
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faFacebook} /> Facebook
                      </label>
                      <input
                        type="text"
                        className="product-form-input"
                        value={nuevoFacebook}
                        onChange={(e) => setNuevoFacebook(e.target.value)}
                        placeholder="@facebook"
                        maxLength={80}
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faEnvelope} /> Email
                      </label>
                      <input
                        type="email"
                        className="product-form-input"
                        value={nuevoEmail}
                        onChange={(e) => setNuevoEmail(e.target.value)}
                        placeholder="correo@dominio.com"
                        maxLength={120}
                      />
                    </div>

                    <div className="product-form-group">
                      <label className="product-form-label">
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> Dirección
                      </label>
                      <input
                        type="text"
                        className="product-form-input"
                        value={nuevaDireccion}
                        onChange={(e) => setNuevaDireccion(e.target.value)}
                        placeholder="Dirección"
                        maxLength={160}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="product-submit-section">
              <button className="btn-product-secondary" onClick={cerrarModal}>
                Cancelar
              </button>
              <button
                className="btn-product-primary"
                onClick={() => handleUpdateText(contacto.idContacto)}
                disabled={!nuevoNombre?.trim()}
              >
                Guardar cambios
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tabla global de contactos */}
      <div className="global-table-container">
        {loading ? (
          <div className="global-loading-state">
            <FontAwesomeIcon icon={faSpinner} size="2x" />
            <div>Cargando contactos...</div>
          </div>
        ) : contactos.length > 0 ? (
          <table className="global-table">
            <thead>
              <tr>
                <th>ID</th>
                <th><FontAwesomeIcon icon={faUser} style={{ marginRight: 8 }} />Nombre</th>
                <th><FontAwesomeIcon icon={faPhone} style={{ marginRight: 8 }} />Teléfono</th>
                <th><FontAwesomeIcon icon={faInstagram} style={{ marginRight: 8 }} />Instagram</th>
                <th><FontAwesomeIcon icon={faFacebook} style={{ marginRight: 8 }} />Facebook</th>
                <th><FontAwesomeIcon icon={faEnvelope} style={{ marginRight: 8 }} />Email</th>
                <th><FontAwesomeIcon icon={faMapMarkerAlt} style={{ marginRight: 8 }} />Dirección</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {contactos.map((item, index) => (
                <tr key={item.idContacto} style={{ animationDelay: `${index * 0.05}s` }}>
                  <td>{item.idContacto}</td>
                  <td><strong>{item.nombre}</strong></td>
                  <td>{item.telefono}</td>
                  <td>
                    {item.instagram ? (
                      <a href={item.instagram} target="_blank" rel="noreferrer" className="text-link">
                        {item.instagram}
                      </a>
                    ) : <span className="text-muted">—</span>}
                  </td>
                  <td>{item.facebook || <span className="text-muted">—</span>}</td>
                  <td>{item.email || <span className="text-muted">—</span>}</td>
                  <td>{item.direccion || <span className="text-muted">—</span>}</td>
                  <td>
                    <div className="global-table-actions">
                      <button className="global-btn-edit" title="Editar" onClick={() => abrirModal(item)}>
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        className="global-btn-delete"
                        title="Eliminar"
                        onClick={() => eliminarContacto(item.idContacto)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="global-empty-state">
            <FontAwesomeIcon icon={faAddressBook} size="3x" />
            <div className="global-empty-title">No hay contactos</div>
            <div className="global-empty-description">
              Crea tu primer contacto con el formulario superior. Usa el botón “Actualizar” para recargar la lista.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
